import { render, staticRenderFns } from "./Outbox.vue?vue&type=template&id=5535f5c4"
import script from "./Outbox.vue?vue&type=script&lang=js"
export * from "./Outbox.vue?vue&type=script&lang=js"
import style0 from "./Outbox.vue?vue&type=style&index=0&id=5535f5c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports